import { writable } from 'svelte/store';
export const breatheState = writable('paused');